import { Node, mergeAttributes } from '@tiptap/core'

export interface YouTubeOptions {
  HTMLAttributes: Record<string, unknown>
}

declare module '@tiptap/core' {
  interface Commands<ReturnType> {
    youtube: {
      setYouTubeVideo: (options: { videoId: string }) => ReturnType
    }
  }
}

export const YouTube = Node.create<YouTubeOptions>({
  name: 'youtube',

  group: 'block',

  atom: true,

  addOptions() {
    return {
      HTMLAttributes: {},
    }
  },

  addAttributes() {
    return {
      videoId: {
        default: null,
      },
    }
  },

  parseHTML() {
    return [
      {
        tag: 'div[data-youtube-video]',
        getAttrs: (node) => {
          if (typeof node === 'string') return false
          const videoId = node.getAttribute('data-youtube-video')
          return videoId ? { videoId } : false
        },
      },
    ]
  },

  renderHTML({ node, HTMLAttributes }) {
    const videoId = node.attrs.videoId
    const thumbnailUrl = `https://img.youtube.com/vi/${videoId}/maxresdefault.jpg`
    const videoUrl = `https://www.youtube.com/watch?v=${videoId}`

    // Play button SVG as data URI
    const playButtonDataUri = `data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 68 48'%3E%3Cpath d='M66.52,7.74c-0.78-2.93-2.49-5.41-5.42-6.19C55.79,.13,34,0,34,0S12.21,.13,6.9,1.55C3.97,2.33,2.27,4.81,1.48,7.74C0.06,13.05,0,24,0,24s0.06,10.95,1.48,16.26c0.78,2.93,2.49,5.41,5.42,6.19C12.21,47.87,34,48,34,48s21.79-0.13,27.1-1.55c2.93-0.78,4.64-3.26,5.42-6.19C67.94,34.95,68,24,68,24S67.94,13.05,66.52,7.74z' fill='%23FF0000'/%3E%3Cpath d='M 45,24 27,14 27,34' fill='%23FFFFFF'/%3E%3C/svg%3E`

    return [
      'div',
      mergeAttributes(this.options.HTMLAttributes, HTMLAttributes, {
        'data-youtube-video': videoId,
        'class': 'youtube-video-container',
        'style': 'max-width: 600px; width: 100%; margin: 8px 0; text-align: center; display: block;',
      }),
      [
        'a',
        {
          href: videoUrl,
          target: '_blank',
          rel: 'noopener noreferrer',
          class: 'youtube-video-link',
          style: 'display: block; position: relative; text-decoration: none; border-radius: 8px; overflow: hidden;',
        },
        [
          'img',
          {
            src: thumbnailUrl,
            alt: 'YouTube Video',
            class: 'youtube-thumbnail',
            style: 'width: 100%; display: block; border-radius: 8px;',
          },
        ],
        [
          'img',
          {
            src: playButtonDataUri,
            alt: 'Play',
            class: 'youtube-play-button',
            style: 'position: absolute; top: 50%; left: 50%; transform: translate(-50%, -50%); width: 68px; height: 48px; pointer-events: none;',
          },
        ],
      ],
    ]
  },

  addCommands() {
    return {
      setYouTubeVideo:
        (options) =>
        ({ commands }) => {
          return commands.insertContent({
            type: this.name,
            attrs: options,
          })
        },
    }
  },
})
